<template>
  <v-container>
    <v-data-table
        loading-text="Loading..."
        class="mb-2"
        :loading="loadingContacts"
        :headers="headersContacts"
        :items="plannedContacts"
        :options.sync="paginationContacts"
        :footer-props="footerOptions"
        :page.sync="currentPage"
        :server-items-length="totalItems"
        :items-per-page-options="rowsPerPageItems"
        mobile-breakpoint="0"
    >
      <template v-slot:item.is_successful="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                v-bind="attrs"
                v-on="on"
                depressed
                elevation="2"
                icon
                @click="updateSuccessfulState(item)">
              <v-icon :color="plannedContactIcon(item.is_successful).color">{{ plannedContactIcon(item.is_successful).name }}</v-icon>
            </v-btn>
          </template>
        <span>{{ plannedContactIcon(item.is_successful).tooltip }}</span>
      </v-tooltip>
      </template>

      <template v-slot:item.description="{ item }">
          <v-edit-dialog
              large
              @save="updateContact(item)"
              persistent
              :return-value.sync="item.description"
          > 
            {{ item.description }}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                >
                  <v-icon size="20px" color="fontDefault" class="mb-1">edit</v-icon>
                </v-btn> 
              </template>
              <span>{{ languageData.operation.edit }}</span>
            </v-tooltip>
            <template v-slot:input>
              <v-textarea
                  class="mt-5"
                  v-model="item.description"
                  :label="languageData.labels.description"
                  outlined
              ></v-textarea>
            </template>
          </v-edit-dialog> 
      </template>
      <template v-slot:item.planned_at="{ item }">
          <td>
            {{ plannedAtDate(item.planned_at) }}
          </td>
          <td>&nbsp;</td>
          <td>
            {{ plannedAtHours(item.planned_at)}}
          </td>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                v-bind="attrs"
                v-on="on"
                @click="showDeleteContactModal(item)"
                icon>
              <v-icon color="fontDefault">delete</v-icon>
            </v-btn>
          </template>
          <span>{{ languageData.plannedContacts.deleteContact }}</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <ModalInfo :visDisAgreeBtn="true"
               @doOperation="removeContact(plannedContacts.indexOf(contactToDelete), contactToDelete.id)"
               :typeInfo="'info'" :btnDisAgreeText="languageData.modalDeleteContact.btnDisAgreeText"
               :headModal="languageData.modalDeleteContact.head" :btnAgreeText="languageData.btnAgreeText"
               @clicked="hideModalContact" :show-modal="isShowModalDeletePlannedContact"
               :text-modal="languageData.modalDeleteContact.textInfo + ' ' + contactToDelete.description"></ModalInfo>
    <ModalInfo
        :head-modal="languageData.plannedContacts.addContactToProjectEntries"
        @clicked="hideAddContactToEntriesModal"
        @doOperation="addContactToProjectReport"
        :show-modal="showAddContactToEntriesModal"
        :visDisAgreeBtn="true"
        :btnDisAgreeText="languageData.btnDisAgreeText"
        :btnAgreeText="languageData.btnAgreeText"
        :text-modal="languageData.plannedContacts.textModalAddContact">
      </ModalInfo>
  </v-container>
</template>

<script type="text/javascript">
import {mapActions, mapState} from "vuex";
import ModalInfo from "../../../components/ModalInfo/ModalInfo";
import eventBus from "../../../event-bus/eventBus";
import moment from "moment";

export default {
  name: "PlannedContactsTable",
  props: {
    contactableType: String
  },
  components: {
    ModalInfo
  },
  data() {
    return {
      footerOptions: {
        'items-per-page-options': [5, 15, 30],
        'disablePagination': false
      },
      currentPage: 1,
      plannedContacts: [],
      contactToDelete: {},
      updatedContact: {},
      contactIcons: [],
      showAddContactToEntriesModal: false,
      plannedContact: {},
    }
  },
  computed: {
    ...mapState("getPlannedContacts", {
      plannedContactsReceive: state => state.dataReceive,
      totalItems: state => state.pagination.totalItems,
      rowsPerPageItems: state => state.pagination.rowsPerPage,
      headers: state => state.headers,
      sortBy: state => state.pagination.sortBy,
      loadingContacts: state => state.loadingContacts,
      chosenClient: state => state.chosenClient,
    }),
    ...mapState("deletePlannedContact", {
      isShowModalDeletePlannedContact: state => state.isShowModalDeletePlannedContact
    }),
    ...mapState("getHeadersPlannedContacts", {
      headersContacts: state => state.headers
    }),
    paginationContacts: {
      set: function (value) {
        this.searchPlannedContacts(value);
      },
      get: function () {
        return this.$store.state.getPlannedContacts.pagination;
      }
    },
  },
  methods: {
    ...mapActions("getHeadersPlannedContacts", ["getHeadersPlannedContacts"]),
    ...mapActions("deletePlannedContact", ["deletePlannedContact", "updateVisibleModalDeletePlannedContact"]),
    ...mapActions("updatePlannedContact", ["updatePlannedContact"]),
    ...mapActions("getPlannedContacts", ["getPlannedContacts"]),
    ...mapActions("saveProjectEntry", ['storeProjectEntry']),

    searchPlannedContacts: function (valueSearch = {}, filters = false) {
      valueSearch.language = this.getCurrentLanguage;
      valueSearch.filters = filters;
      valueSearch.contactableType = this.contactableType;
      this.getPlannedContacts({valueSearch});
      if (filters) {
        this.currentPage = 1;
      }
    },
    plannedContactIcon(state) {
      if (state == true) {
        return  {
          color: 'green',
          name: 'mdi-thumb-up',
          tooltip: this.languageData.plannedContacts.switchToUnsuccessful
        }
      } else if (state == false) {
        return {
          color: 'red',
          name: 'mdi-close-thick',
          tooltip: this.languageData.plannedContacts.switchToUnknown
        }
      } else {
        return  {
          color: 'grey',
          name: 'mdi-help-circle',
          tooltip: this.languageData.plannedContacts.switchToSuccessful
        }
      }
    },
    removeContact: function (index, id) {
      this.plannedContacts.splice(index, 1);
      this.deletePlannedContact({creds: {id}});
    },
    showDeleteContactModal: function (item) {
      this.contactToDelete = item;
      this.updateVisibleModalDeletePlannedContact(true);
    },
    hideModalContact: function () {
      this.updateVisibleModalDeletePlannedContact(false);
    },
    updateContact: function (item) {
      let id = item.id;
      let data = item;
      data.chosenClient = this.chosenClient;
      item.contactableType = this.contactableType;
      this.updatePlannedContact({creds: {id, data}});
    },
    updateSuccessfulState: function (item) {
      let id = item.id;
      let data = item;
      data.contactableType = this.contactableType;
      if (data.is_successful == null) {
        data.is_successful = true;
      } else if (data.is_successful == true) {
        data.is_successful = false;
      } else if (data.is_successful == false) {
        data.is_successful = null;
      }

      data.chosenClient = this.chosenClient;
      this.updatePlannedContact({creds: {id, data}})
    },
    plannedAtDate(item) {
      return moment(item).format('Y-M-D');
    },
    plannedAtHours(item) {
      return moment(item).format('H:mm')
    },
    hideAddContactToEntriesModal() {
      this.showAddContactToEntriesModal = false;
    },
    addContactToProjectReport() {
      this.plannedContact = {};
      this.showAddContactToEntriesModal = false;
    },
  },
  mounted() {
    const language = this.getCurrentLanguage;

    this.getHeadersPlannedContacts({creds: {language}});

    eventBus.$on("setDisablePagination", (value) => {
      this.footerOptions.disablePagination = value;
    });

    eventBus.$on("getContactsSuccess", (data) => {
      this.plannedContacts = data;
    });

    eventBus.$on("savePlannedContactSuccess", (dataReceive) => {
      this.searchPlannedContacts({});
      if(dataReceive.plannedContact.contactable_type.includes('ProjectClients')) {
        this.plannedContact = dataReceive.plannedContact;
        this.plannedContact.projectId = dataReceive.projectId;
        this.showAddContactToEntriesModal = true;
      }
    });

    eventBus.$on("updatePlannedContactSuccess", () => {
      this.searchPlannedContacts({});
    });

    eventBus.$on("deletePlannedContactSuccess", () => {
      this.searchPlannedContacts({});
    });

    eventBus.$on("getPlannedContacts", () => {
      this.plannedContacts = [];
      console.log(this.contactableType);
      this.searchPlannedContacts({});
    })
  },
  beforeDestroy() {
    eventBus.$off('updatePlannedContactSuccess');
    eventBus.$off('deletePlannedContactSuccess');
    eventBus.$off('savePlannedContactSuccess');
  }

}
</script>